import Tag from '@/components/Content/Tag';

import styles from './index.module.scss';

interface PlusTagProps {
  size?: 'small' | 'large';
}

const PlusTag = ({ size = 'small' }: PlusTagProps) => {
  return (
    <div className={styles.root}>
      <Tag
        text={'PLUS +'}
        size={size}
        theme="custom"
        background="linear-gradient(90deg, #3B97EE 0%, #9A26FF 100%), linear-gradient(90deg, #1D78CE 0%, #06CD87 100%)"
      />
    </div>
  );
};

export default PlusTag;
